var get = require('./get');

    var UNDEF;

    /**
     * Check if object has nested property.
     */
    function has(obj, prop){
        return get(obj, prop) !== UNDEF;
    }

    module.exports = has;






//////////////////
// WEBPACK FOOTER
// ./~/mout/object/has.js
// module id = 712
// module chunks = 0 1 2